export default __webpack_public_path__ + "static/media/mastercard-icon.ff12ba84.svg";